// extracted by mini-css-extract-plugin
module.exports = {"policy":"Policy-styles-module--policy--8TgTn","dismissed":"Policy-styles-module--dismissed--1xIf_"};